// extracted by mini-css-extract-plugin
var _1 = "actions-NbJdm";
var _2 = "grand-HpAFl";
var _3 = "link-GbJlR";
var _4 = "name-tzTBI";
var _5 = "title-h_IOE";
var _6 = "total-JrCRV";
export { _1 as "actions", _2 as "grand", _3 as "link", _4 as "name", _5 as "title", _6 as "total" }
